import ErrorBoundary, { withErrorBoundary } from './ErrorBoundary';

export { withErrorBoundary };

export default ErrorBoundary;
